// Microsoft Entra ID (Azure AD) SSO configuration using MSAL
// See: https://learn.microsoft.com/en-us/entra/identity-platform/tutorial-single-page-app-react-register-app

export const msalConfig = {
  auth: {
    clientId: "2d0d155c-6769-4dc9-8a4f-035ac49a5d74", // App ID from Azure AD app registration
    authority: "https://login.microsoftonline.com/organizations",
    redirectUri: window.location.origin, // e.g. http://localhost:3000 in dev
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// Request User.Read scope for basic authentication
// Roles will be extracted from the token if assigned in Entra ID
export const loginRequest = {
  scopes: ["User.Read"],
};
